import ChatConversation from "./ChatConversation";

export default class ChatModel {
    constructor() {
        /** @type {Object.<string, ChatConversation>} */
        this._conversationsByNpcId = {};
    }

    get conversations() {
        return Object.values(this._conversationsByNpcId);
    }

    get contactIds() {
        return Object.keys(this._conversationsByNpcId);
    }

    /**
     * Ensures a chat conversation for the given npc id
     * @param {string} npcId 
     */
    ensureConversationForNpcId(npcId) {
        if (!this._conversationsByNpcId.hasOwnProperty(npcId)) {
            const conversation = new ChatConversation(npcId);

            this._conversationsByNpcId[npcId] = conversation;
        }
    }

    /**
     * Gets the conversation for the given npc id
     * @param {string} npcId 
     * @returns {ChatConversation}
     */
    getConversationForNpcId(npcId) {
        return this._conversationsByNpcId[npcId];
    }

    /**
     * Geets the amount of unread messages in all conversations
     * @returns {number} The amount of unread messages in all conversations
     */
    getUnreadCount() {
        return this.conversations.reduce((prev, curr) => prev + curr.getUnreadCount(), 0);
    }
    

    toObject() {
        let serializableConversationsByNpcId = {};
        for (const npcId in this._conversationsByNpcId) {
            const conversation = this._conversationsByNpcId[npcId];
            serializableConversationsByNpcId[npcId] = conversation.toObject();
        }

        return {
            conversationsByNpcId: serializableConversationsByNpcId
        };
    }

    fromObject(obj, languagePack) {
        Object.keys(obj.conversationsByNpcId).map(k => {
            this._conversationsByNpcId[k] = new ChatConversation().fromObject(obj.conversationsByNpcId[k], languagePack);
        });
    }
}